import React, { useEffect, useRef, useState } from "react";
import * as echarts from "echarts";

const DdChart = ({ ddInfo, chartTypeLinOrLog }) => {
  const chartRef = useRef(null);
  const [chart, setChart] = useState(null);
  const [masterLoad, setMasterLoad] = useState(false);
  const [injShow, setInjShow] = useState(false);
  const [injLoaded, setInjLoaded] = useState(false);
  const [siteName, setSiteName] = useState("");
  const [chartType, setChartType] = useState("value");

  //! Possibly have to do this with other volumes as in if there is 0 across the board don't show it
  useEffect(() => {
    console.log("chartTypeLinOrLog in UE", chartTypeLinOrLog);
  }, [chartTypeLinOrLog]);
  useEffect(() => {
    setChartType(chartType);
  }, [chartType]);
  useEffect(() => {
    // console.log("ddinfo UE start");
    // console.log("ddInfo in UE", ddInfo);
    setMasterLoad(false);
    const getSiteName = () => {
      if (ddInfo.length > 0) {
        console.log("site name in UE", ddInfo[0].userRef);
        setSiteName(ddInfo[0].userRef);
        setMasterLoad(true);
      } else {
        console.log("no data in UE");
        setMasterLoad(false);
      }
    };
    const checkInjectedVolume = () => {
      const hasInjectedVolume = ddInfo.some(
        (item) => parseFloat(item.injectedVolume) > 0
      );
      if (hasInjectedVolume) {
        setInjShow(true);
        getSiteName();
        // setMasterLoad(true);
      } else {
        setInjShow(false);
        getSiteName();
        // setMasterLoad(true);
      }
    };
    console.log("running checks for inj and name");
    checkInjectedVolume();
  }, [ddInfo]);

  useEffect(() => {
    console.log("injectedVolume UE", injShow);
  }, [injShow]);
  useEffect(() => {
    console.log("site name UE", siteName);
  }, [siteName]);

  useEffect(() => {
    console.log("masterload in UE", masterLoad);
    if (masterLoad === false) {
      console.log("master load false");
      return;
    } else {
      console.log("master load true");
      console.log("data in DDCHART", ddInfo);
      if (!ddInfo || ddInfo.length === 0) {
        console.log("data is empty");
        return;
      }

      const chart = echarts.init(chartRef.current);

      const xAxisData = ddInfo.map((entry) => entry.date);
      const grossOilData = ddInfo.map((entry) =>
        entry.grossOil === null || entry.grossOil === undefined
          ? null
          : entry.grossOil
      );
      const grossGasData = ddInfo.map((entry) =>
        entry.grossGas === null || entry.grossGas === undefined
          ? null
          : entry.grossGas
      );
      const grossWaterData = ddInfo.map((entry) =>
        entry.grossWater === null || entry.grossWater === undefined
          ? null
          : entry.grossWater
      );
      const injectedVolume = ddInfo.map((entry) =>
        entry.injectedVolume === null || entry.injectedVolume === undefined
          ? null
          : entry.injectedVolume
      );

      const option = {
        title: {
          text: `Daily Production Summary for ${siteName}`,
          left: "center",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          bottom: 0,
          left: "center",
          data: ["Gross Oil", "Gross Gas", "Gross Water", "Injection Volume"],
          selected: {
            "Gross Oil": true,
            "Gross Gas": true,
            "Gross Water": true,
            "Injection Volume": injShow,
          },
        },
        xAxis: {
          type: "category",
          data: xAxisData,
        },
        yAxis: {
          // * ISSUE#61 - Added log scale to the y-axis by adding min and max.
          // type: "value",
          type: chartTypeLinOrLog,
          min: 1,
          max: "dataMax",
          scale: true,
        },
        series: [
          {
            name: "Gross Oil",
            type: "line",
            data: grossOilData,
            color: "green",
            connectNulls: false,
          },
          {
            name: "Gross Gas",
            type: "line",
            data: grossGasData,
            color: "red",
            connectNulls: false,
          },
          {
            name: "Gross Water",
            type: "line",
            data: grossWaterData,
            color: "blue",
            connectNulls: false,
          },
          {
            name: "Injection Volume",
            type: "line",
            data: injectedVolume,
            color: "rgb(5, 192, 253)",
            connectNulls: false,
          },
        ],
      };

      chart.setOption(option);

      const resizeChart = () => {
        chart.resize();
      };

      window.addEventListener("resize", resizeChart);

      // Clean up
      return () => {
        chart.dispose();
      };
    }
  }, [masterLoad]);

  return (
    <div
      id="ddChart"
      style={{ width: "100%", height: "400px" }}
      ref={chartRef}
    />
  );
};

export default DdChart;
